import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-attachments-form-uploader',
  template: `
    <div class="attachments-form__uploader">
      <input
        #fileInput
        class="attachments-form__uploader-core"
        type="file"
        (change)="onFilesReceive(fileInput.files); fileInput.value = ''"
        [multiple]="true"
        [disabled]="disabled"
      />
      <div
        class="attachments-form__uploader-drop-zone"
        [class.isActive]="isDragging$ | async"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="!disabled && onDrop($event)"
      >
        <button class="btn btn-default" [disabled]="disabled" (click)="!disabled && fileInput.click()">
          <span>BROWSE YOUR COMPUTER</span>
        </button>
        <span>OR, Drag-and-Drop Files Here</span>
      </div>
    </div>
  `,
  styleUrls: ['../styles/attachments-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttachmentsFormUploaderComponent {
  @Input() public disabled: boolean = false;

  @Output() public filesAdded: EventEmitter<File[]> = new EventEmitter<File[]>();

  public isDragging$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public onDragOver = ($event: Event): void => {
    $event.preventDefault();
    $event.stopPropagation();

    this.isDragging$.next(true);
  };

  public onDragLeave = ($event: Event) => {
    $event.preventDefault();
    $event.stopPropagation();

    this.isDragging$.next(false);
  };

  public onDrop = ($event: DragEvent): void => {
    $event.preventDefault();
    $event.stopPropagation();

    this.isDragging$.next(false);
    this.onFilesReceive($event.dataTransfer.files);
  };

  public onFilesReceive = (data: FileList | File[]): void => {
    this.filesAdded.emit(Array.from(data));
  };
}
